/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon16Regular = forwardRef('WeatherThermometerIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.875 10.75A1.875 1.875 0 1 1 7.25 9.031V5.5a.75.75 0 0 1 1.5 0v3.531c.662.29 1.125.95 1.125 1.719Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 4a3.5 3.5 0 1 1 7 0v3.539a4.75 4.75 0 1 1-7 0V4ZM8 2a2 2 0 0 0-2 2v3.845a.75.75 0 0 1-.234.545 3.25 3.25 0 1 0 4.469 0A.75.75 0 0 1 10 7.845V4a2 2 0 0 0-2-2Z" })));
});
